import { Provider, ProviderSearch } from "../../data/ecommerce/providers";
import { Product } from "../../data/ecommerce/storeCatalog";
import apiHandler from "../apiHandler";

export const getProviderById = async (providerId: number): Promise<Provider> => {
    const provider = await apiHandler({
        endpoint: `/providers/${providerId}`,
        method: 'GET',
    });

    if (!provider) {
        throw new Error('No provider found');
    }

    return provider;
};

export const getProductsofProvider = async (providerId: number): Promise<Product[]> => {
    const products = await apiHandler({
        endpoint: `/providers/${providerId}/products`,
        method: 'GET',
    });

    if (!products) {
        throw new Error('No products found for this provider');
    }

    return products;
}

export const getProviders = async ({ params }: { params?: Record<string, any> } = {}): Promise<ProviderSearch> => {
    const providers = await apiHandler({
        endpoint: '/providers',
        method: 'GET',
        params: params,
    });

    if (!providers) {
        throw new Error('No providers found');
    }

    return providers;
};

interface GalleryResponse {
    data: Array<{
        imageId: string;
        thumbnailId: string;
    }>;
    paginationInfo: {
        pageNumber: number;
        pageSize: number;
        totalPages: number;
        totalRecords: number;
    };
}

export const getProviderGallery = async (providerId: number): Promise<GalleryResponse> => {
    const gallery = await apiHandler({
        endpoint: `/providers/${providerId}/gallery`,
        method: 'GET',
    });

    if (!gallery) {
        throw new Error('No gallery found for this provider');
    }

    return gallery;
};
